/**
 * Form related functionality
 *
 * This file fixes elementor widget form problems with date filed and calendar translation
 * to be able to use translation flatpickr needs to be installed first via "npm i flatpickr"
 * https://flatpickr.js.org/
 * load from node_modules
 * Only focused on german in this class
 */
import { German } from "flatpickr/dist/l10n/de.js"

export default class Form {

    constructor(dateFormat = 'd.m.Y', pattern = '[0-9]{2}.[0-9]{2}.[0-9]{4}', time_24hr = true, language = German) {

        this.dateFormat = dateFormat;
        this.pattern = pattern;
        this.time_24hr = time_24hr;
        this.language = language;
        this.init();
    }
    
    init() {

        this.dateCalendar();
    }

    // ================================
    // Adjust calendar and date format
    //
    dateCalendar() {

        if( typeof ( flatpickr ) == "function" ) {

            flatpickr.setDefaults({
                dateFormat: this.dateFormat,
                time_24hr: this.time_24hr
            });

            // translate via node_modules/flatpickr/dist/l10n/de.js
            // see https://flatpickr.js.org/localization/
            // Localize globally (for all instances):
            flatpickr.localize(this.language);

            // Checks for valid date format
            // default: [0-9]{4}-[0-9]{2}-[0-9]{2}
            // de: [0-9]{2}.[0-9]{2}.[0-9]{4}
            jQuery('.elementor-date-field').attr('pattern', this.pattern);
        }
    }
}